import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

import AdminLayout from "../src/layouts/Dash/Admin.jsx";


ReactDOM.render(
  <HashRouter>
    <Switch>
      <Route key="home" path="/home" render={props => <AdminLayout {...props}/>} />
      <Redirect from="/" to="/home" />
    </Switch>
  </HashRouter>,
  document.getElementById("root")
);

